<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox" @submit.prevent="submit1">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
              v-model="INPUT"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 50 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 人才招聘 -->
      <div class="employ container" style="padding: 0">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>人才招聘</span>
          <img src="../assets/zszs2.png" />
        </div>
        <div class="cont">
          <div class="topBox">
            <div class="hiretop">
              <img src="../assets/hiretop.png" />
            </div>
            <div class="join">
              <div>
                <p class="top">
                  <img src="../assets/my.png" />
                  <span>加入采航贸易</span>
                </p>
                <p class="mid">成为我们的一员，请将简历投递至邮箱</p>
              </div>
              <p class="bottom"><span>ast@astsciencecorp.com.cn</span></p>
            </div>
          </div>
          <ul class="hireList" v-if="recruitList.length > 0">
            <li
              class="hire-item"
              v-for="(item, index) in recruitList"
              :key="index"
            >
              <div class="top">
                <p class="left">
                  <span>{{ item.RE_TITLE }}</span>
                  <span
                    ><label>{{ item.RE_WAGES }}</label> |
                    {{ item.RE_ADDRESS }} | {{ item.RE_LEARN }}</span
                  >
                </p>
              </div>
              <div class="details">
                <div class="duty">
                  <p class="dutyTitle" style="font-weight: bold">职位职责</p>
                  <pre>{{ item.RE_DUTY }}</pre>
                </div>
                <div class="require">
                  <p class="requireTitle" style="font-weight: bold">职位要求</p>
                  <pre>{{ item.RE_REQUIRE }}</pre>
                </div>
              </div>
            </li>
          </ul>
          <div class="searchResult" v-if="recruitList.length == 0">
            暂无招聘列表！
          </div>
          <div class="pagesBlock" v-if="sumPages > 1">
            <flPagination
              :totalPage="sumPages"
              :current="1"
              @on-change="handlePageChange"
            ></flPagination>
          </div>
        </div>
      </div>

      <!-- 提醒弹窗 -->
      <div class="modal-bg" v-if="isShow4">
        <div class="modal-container">
          <div class="modal-top">
            <p class="modal-title">信息</p>
            <img
              src="../assets/cancel.png"
              class="close"
              @click="hideModal()"
            />
          </div>

          <div class="modal-main">{{ message }}</div>
          <div class="modal-bottom">
            <p class="confirmBtn" @click="hideModal">确定</p>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>
/* 标题 */
.toptitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  line-height: 1.875rem;
  font-size: 1.9375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e2e2e;
  margin: 4.375rem 0 3.125rem;
}

.toptitle img {
  width: 4.8125rem;
  height: 0.875rem;
}

.toptitle span {
  margin: 0 1.3125rem;
}

/* 人才招聘 */
.topBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 12.625rem;
}

.topBox .hiretop,
.topBox .join {
  width: 49.1%;
  height: 100%;
}

.topBox .join .top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

p {
  margin: 0;
}

.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.modal-container {
  width: 17.5rem;
  border-radius: 0.3125rem;
  background: #fff;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.625rem;
  box-sizing: border-box;
}

.modal-top .close {
  width: 0.9375rem;
  height: 0.9375rem;
}

.modal-main {
  text-align: left;
  padding: 1.25rem 2.5rem;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: 1.25rem;
  margin-bottom: 0.9375rem;
  box-sizing: border-box;
}

.confirmBtn {
  line-height: 0.875rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  background: #020e62;
  padding: 0.625rem 1.25rem;
}

@media (max-width: 768px) {
  .employ {
    max-width: 90% !important;
  }
}

@media (min-width: 500px) and (max-width: 670px) {
  .employ {
    max-width: 90% !important;
  }

  .topBox {
    height: 11rem !important;
  }

  .topBox .join {
    line-height: 1.2rem !important;
    font-size: 1.2rem !important;
  }

  .mid {
    line-height: 1rem !important;
    font-size: 0.8rem !important;
    margin: 1.0625rem 0 0.9375rem !important;
  }
}

.topBox .hiretop img {
  width: 100%;
  height: 100%;
}

.topBox .join {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  line-height: 1.375rem;
  font-size: 1.375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #020e62;
  border: 2px solid #020e62;
  padding: 0 0 0 3%;
  box-sizing: border-box;
}

.topBox .join img {
  margin-right: 1.75rem;
}

.mid {
  line-height: 1.0625rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5f5f5f;
  margin: 1.0625rem 0 0.9375rem;
}

.join .bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.4375rem;
  line-height: 0.8125rem;
  font-size: 0.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
  border-radius: 0.125rem;
  padding: 0 0.625rem;
}

.join .bottom span {
  height: 0.8125rem;
}

.hireList {
  margin-bottom: 1.25rem;
}

.searchResult {
  width: 100%;
  line-height: 1.5rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #333;
  margin: 2rem 0;
}

.hire-item .top {
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #d0d0d0;
  text-align: left;
  padding: 1.125rem 0;
}

.hire-item .top span:first-of-type {
  line-height: 1.25rem;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-right: 2.125rem;
}

.hire-item .top span:nth-of-type(2) {
  line-height: 0.9375rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
}

.hire-item .top span:nth-of-type(2) label {
  line-height: 0.75rem;
  font-size: 0.875rem;
  color: #020e62;
}

.hire-item .details {
  line-height: 1.3125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  text-align: left;
  padding-top: 0.2813rem;
  margin: 0;
}

.hire-item .details .require {
  margin-top: 0.25rem;
}

.hire-item .details pre {
  line-height: 1.75rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  text-align: left;
  white-space: pre-line;
  margin-top: 0.4063rem;
}

.hire-item .details .require pre {
  margin-bottom: 0.5625rem;
}

/* 分页 */
.pagesBlock {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 1.25rem;
}

@media (max-width: 499px) {
  .toptitle span {
    margin: 0 1.125rem !important;
  }
  .employ {
    max-width: 100% !important;
  }

  .topBox {
    flex-direction: column;
    height: auto !important;
  }

  .topBox .hiretop {
    width: 100%;
    padding-left: 2% !important;
    padding-right: 2% !important;
    box-sizing: border-box;
  }

  .topBox .join {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 96%;
    margin-left: 2% !important;
    margin-right: 2% !important;
    line-height: 1rem !important;
    font-size: 0.8rem !important;
    margin-top: 0.625rem;
    padding: 0.625rem 2% !important;
  }

  .topBox .join img {
    width: 1.5625rem;
    height: 1.5625rem;
    margin-right: 0.5rem !important;
  }

  .mid {
    line-height: 0.8rem !important;
    font-size: 0.6rem !important;
    margin: 0.8rem 0 0.6rem !important;
  }

  .join .bottom {
    height: 2.4375rem !important;
    line-height: 0.8rem !important;
    font-size: 0.8rem !important;
    padding: 0 0.25rem !important;
    box-sizing: border-box;
  }

  .join .bottom span {
    height: 0.5rem !important;
  }

  .hire-item .top {
    width: 100%;
    padding: 1.125rem 2% 0.7rem !important;
    box-sizing: border-box;
  }

  .top .left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .top .left span:first-of-type {
    line-height: 1.1rem !important;
    font-size: 1rem !important;
    margin-right: 0 !important;
    margin-bottom: 0.625rem;
  }

  .top .left span:nth-of-type(n + 2) {
    line-height: 0.9rem !important;
    font-size: 0.8rem !important;
    margin-right: 0 !important;
    margin-bottom: 0;
  }

  .hire-item .details {
    width: 100%;
    line-height: 1.1rem;
    font-size: 0.9rem;
    padding-left: 2% !important;
    padding-right: 2% !important;
    box-sizing: border-box;
  }

  .hire-item .details pre {
    line-height: 1.3rem;
    font-size: 0.8rem;
    margin-top: 0.4rem;
    margin-bottom: 0.6rem;
  }

  .hire-item .details .require {
    margin-top: 0;
  }

  .searchResult {
    width: 100%;
    padding: 0 2%;
    box-sizing: border-box;
  }
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import flPagination from "@/components/Pagination.vue";
import { getBackground, getRecruit } from "../api/interface"; // 引入接口
export default {
  name: "hireView",
  components: {
    bottomFooter,
    flPagination,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      INPUT: "",
      PULLNUM: 1, //当前页，起始值是1
      recruitList: [],
      sumPages: 0, //总共几页
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
      message: "",
      isShow4: false, //是否展示消息弹窗
    };
  },

  created() {
    this.getImg();
    this.getRecruit();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;
      console.log("scrollTop", scrollTop);
      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 50) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "talent-recruitment" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 是否展示消息弹窗
    hideModal() {
      this.$set(this, "isShow4", false);
    },

    // 提交表单
    submit1(e) {
      e.preventDefault(); // 阻止默认提交行为
      console.log(this.INPUT);
      if (this.INPUT == "") {
        this.$set(this, "message", "请输入关键词！");
        this.$set(this, "isShow4", true);
      }
      this.getRecruit();
    },

    // 获取招聘信息
    async getRecruit() {
      const that = this;
      await getRecruit({ INPUT: that.INPUT, PULLNUM: that.PULLNUM }).then(
        (res) => {
          console.log(res);
          that.$set(that, "sumPages", res.page.totalPage);
          that.$set(that, "PULLNUM", res.page.currentPage);
          let recruitList = res.recruit;
          recruitList.forEach((v) => {
            v[`isOpen`] = false;
          });
          that.$set(that, "recruitList", recruitList);
        }
      );
    },

    // 页码变更
    handlePageChange(page) {
      const that = this;
      console.log("当前页码：" + page);
      that.$set(that, "PULLNUM", page);
      that.getRecruit();
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
